import axios from 'axios'
import {Encrypt} from '@/utils/crypto'
import {getToken, removeToken} from '@/utils/auth'
import {msgBoxNoLogin, msgBoxNoRole, msgError} from './dw-msg'
import DwAuthorized from './dw-authorized'

// 全局的 axios 默认值
axios.defaults.baseURL = process.env.DW_API_URL
// 请求超时时间
axios.defaults.timeout = 60000
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.DW_API_URL,
  // 超时
  timeout: 60000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = getToken()
    }
    const authority = DwAuthorized.getAuthority()
    if (authority[0]) {
      config.headers['roleKey'] = authority[0]
    }
    if (!(config.data instanceof FormData)) {
      if (Object.prototype.toString.call(config.data) !== '[object Array]') {
        if (config.method === 'post') {
          const data = config.data
          config.data = {
            t: Encrypt(new Date().getTime()),
            ...data
          }
        } else if (config.method === 'get') {
          config.params = {
            t: Encrypt(new Date().getTime()),
            ...config.params
          }
        }
      }
    }
    return config
  },
  error => {
    console.log('request-error:'+error)
    return Promise.error(error)
  })

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      const {data} = response
      if (data.hasOwnProperty('code')) {
        if (data.code === 401) {
          msgBoxNoLogin()
          localStorage.clear()
          removeToken()
        } else if (data.code === 403) {
          msgBoxNoRole()
        } else if (data.code !== 200 && data.code !== 6110 && data.code !== 6111) {
          let message = `异常码：${data.code}`
          if (data.hasOwnProperty('msg')) {
            message = `${data.msg}`
          }
          msgError(message)
        }
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    // 服务器状态码不是200的情况
    console.log('err' + error)
    let {message} = error
    if (message.includes('Network Error')) {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      const code = message.substr(message.length - 3)
      if (code === '401' || code === '403') {
        message=null
        if (code === '401') {
          msgBoxNoLogin()
          localStorage.clear()
          removeToken()
        } else if (code === '403') {
          msgBoxNoRole()
        }
      } else {
        message = '系统接口' + message.substr(message.length - 3) + '异常'
      }
    }
    if (message != null) {
      msgError(message)
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js